import React, { useState } from "react";

const modalStyle = {
    overlay: {
        position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1000,
        display: "flex", justifyContent: "center", alignItems: "center"
    },
    modal: {
        background: "#fff", padding: "1.5rem", borderRadius: "8px",
        width: "90%", maxWidth: "500px", boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        transition: "opacity 0.5s ease"
    }
};

const FeedbackModal = ({ open, onClose, onSubmit, food, swap, explanation }) => {
    const [feedbackText, setFeedbackText] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [fadingOut, setFadingOut] = useState(false);

    if (!open) return null;

    const handleSubmit = async () => {
        await onSubmit(feedbackText);
        setFeedbackText("");
        setSubmitted(true);

        // Start fade-out effect
        setTimeout(() => {
            setFadingOut(true);
        }, 500);

        // Close after fade
        setTimeout(() => {
            setFadingOut(false);
            setSubmitted(false);
            onClose();
        }, 1500);
    };

    return (
        <div style={modalStyle.modal}>
            <div
                style={{
                    opacity: fadingOut ? 0 : 1,
                    transition: "opacity 1s ease"
                }}
            >
                {!submitted ? (
                    <>
                        <h3>📝 Feedback</h3>
                        <p><strong>Food:</strong> {food}</p>
                        <p><strong>Swap:</strong> {swap}</p>
                        <p><strong>Why:</strong> {explanation}</p>
                        <textarea
                            value={feedbackText}
                            onChange={(e) => setFeedbackText(e.target.value)}
                            placeholder="Write your feedback here..."
                            rows={5}
                            style={{ width: "100%", marginTop: "1rem" }}
                        />
                        <div style={{ marginTop: "1rem", textAlign: "right" }}>
                            <button onClick={onClose} style={{ marginRight: "1rem" }}>Cancel</button>
                            <button onClick={handleSubmit} disabled={!feedbackText.trim()}>Submit</button>
                        </div>
                    </>
                ) : (
                    <div style={{ textAlign: "center" }}>
                        <h2 style={{ fontSize: "1.75rem", marginBottom: "0.5rem" }}>Thank you!</h2>
                        <p style={{ fontSize: "0.95rem", color: "#444" }}>
                            We appreciate your time!.
                        </p>
                    </div>
                )}
            </div>
        </div>

    );
};

export default FeedbackModal;
